<div class="relative bg-white rounded-xl shadow-lg px-2 max-h-[24rem] overflow-y-auto custom-scroll"
     [ngClass]="{
       'ml-3 mr-3 lg:ml-2 lg:mr-2 lg:ml-0 mg:mr-0': componentLocation !== 'dashboard',
       '-mt-8 lg:mt-0': componentLocation !== 'dashboard'
     }">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center text-gray-500 text-sm tracking-wide py-6">
    Searching...
  </div>

  <!-- Minimum Words Message -->
  <div *ngIf="message" class="text-center text-gray-500 text-sm tracking-wide py-6">
    {{ message }}
  </div>

  <!-- Results -->
  <ul *ngIf="!message && results.length && !isLoading" class="divide-y divide-gray-100">
    <li *ngFor="let result of results" (click)="selectResult(result)" class="py-2">
      <div class="group grid grid-cols-2 gap-3 hover:bg-gray-50 cursor-pointer rounded-md space-x-2">

        <!-- Person -->
        <div class="col-span-2 lg:col-span-1 bg-transparent flex items-center gap-x-4 rounded-md pl-2">
          <ng-container *ngIf="!imageErrors[getResultId(result)]; else noImageTemplate">
            <img
              class="h-10 w-10 flex-none rounded-full bg-gray-50"
              [src]="(result?.photo_url == null || result?.photo_url == '[]') ? getDefaultAvatar(result.name) : result?.photo_url"
              (error)="onImageError(getResultId(result))"
              [alt]="result.name"
            />
          </ng-container>
          <ng-template #noImageTemplate>
            <img
              class="h-10 w-10 flex-none rounded-full bg-gray-50"
              [src]="getDefaultAvatar(result.name)"
              [alt]="result.name"
            />
          </ng-template>
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-secondary-900">
              <a class="flex items-center">
                {{ result?.name ?? '' }}
              </a>
            </p>
            <p class="flex text-xs leading-5">
              <span class="text-gray-500" *ngIf="result?.country">
                {{ result?.country }} / {{ result?.title?.length > 25 ? (result?.title.slice(0, 25) + '...') : result?.title }}
              </span>
            </p>
          </div>
        </div>

        <!-- Company -->
        <div *ngIf="result.organization" class="col-span-2 lg:col-span-1 flex items-center">
          <div class="bg-violet-50/50 group-hover:bg-gray-100 flex items-center gap-x-4 p-2 rounded-md w-full">
            <ng-container *ngIf="!imageErrors['company_' + getResultId(result)]; else noCompanyImageTemplate">
              <img
                class="h-10 w-10 flex-none rounded-md bg-gray-50"
                [src]="(result.organization?.logo_url == null || result.organization?.logo_url === '[]') ? getDefaultAvatar(result.organization?.name) : result.organization?.logo_url"
                (error)="onImageError('company_' + getResultId(result))"
                alt=""
              />
            </ng-container>
            <ng-template #noCompanyImageTemplate>
              <img
                class="h-10 w-10 flex-none rounded-md bg-gray-50"
                [src]="getDefaultAvatar(result.organization?.name)"
                alt=""
              />
            </ng-template>
            <div class="min-w-0 flex-auto">
              <p class="text-sm font-semibold leading-6 text-secondary-900">
                {{ result.organization?.name ?? '' }}
              </p>
              <p class="flex text-xs leading-5">
              <span class="text-gray-500" *ngIf="result?.country">
                {{ result.organization?.name ?? '' }}
              </span>
              </p>
            </div>
          </div>
        </div>

      </div>
    </li>
  </ul>

  <!-- No Results -->
  <div *ngIf="!message && !results.length && !isLoading" class="text-center text-gray-500 tracking-wide text-sm py-6">
    No results found.
  </div>

</div>
